import React, {useEffect, useState} from 'react'
import {BASE_URL} from '../utils/commonUrl';
import Layout from '../components/Layout'
import axios from 'axios';
import {useDispatch, useSelector} from 'react-redux'
import SkillMatrixForm from "./forms/SkillMatrixForm";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {fetchSkillMatrix} from "../redux/features/skillMatrix.feature";
import { textAlign } from '@mui/system';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const SkillMatrix = () => {    
    const dispatch = useDispatch();
    const state = useSelector((state => state["skillmatrix"]))
    const [modal, setModal] = useState(false)
    const [start, setFirst] = useState(0);    
    const [activeUserRoleNames, setactiveUserRoleNames] = useState([]);// DropDown
    const [isLoading, setIsLoading] = useState(false);
	
    const [skillMatrixItem, setSkillMatrixItem] = useState({
					roleWiseMatrixID: 0,                    
                    userRoleID:0,                  					
					matrixTitle: "",					
					weight: 0,
					rca:0,
                    active: true,
    })

    useEffect(() => {                
        dispatch(fetchSkillMatrix())
        UserRoleActiveNames()        
        initFilters1();
    }, [])
    

    const UserRoleActiveNames = async () => {
        try {
            const url = BASE_URL + '/api/userRole/GetActiveList'
            const response = await axios.get(url)
            if (response.status === 200) {
                const optionList = [{value: '-1', label: '--Please Select Role--'}];
                response.data.map(val => optionList.push({value: val.userRoleID, label: val.roleName}))

                setactiveUserRoleNames(optionList)
            }

        } catch (e) {
            console.log(e)
        }

    }

    const onSubmit = async data => {
        console.log(data);
        try {
            setIsLoading(true)
            const url = BASE_URL + "/api/rolewisematrix";
            const response = await axios.post(url, data);
            setIsLoading(false)
            if (response.status === 200) {
                dispatch(fetchSkillMatrix())
                setSkillMatrixItem({
                    roleWiseMatrixID: 0,                    
                    userRoleID:0,                  					
					matrixTitle: "",					
					weight: 0,
					rca:0,
                    active: true,
                })
                setModal(!modal)
            }
        } catch (e) {
            console.log(e)
            setIsLoading(false)
        }


    }

    const onHide = () => {
        setModal(!modal)
        setSkillMatrixItem({
            roleWiseMatrixID: 0,                    
            userRoleID:0,                  					
            matrixTitle: "",					
            weight: 0,
            rca:0,
            active: true,
        })
    }
	
    const editGridData = data => {
        //console.log(data);
        setSkillMatrixItem({
            roleWiseMatrixID: data.roleWiseMatrixID,                    
            userRoleID:data.userRoleID,                  					
            matrixTitle: data.matrixTitle,					
            weight: data.weight,
            rca:data.rca,
            active: true,
        });
        setModal(!modal);
    }

    const deleteGridData = data => {
        //setDeleteassestmentTitleIndicatorItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    }


    //filter begin

    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }



    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'userRoleID': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },           
            'matrixTitle': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'weight': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'rca': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'active': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }


    //filter end



    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                        onClick={() => editGridData(rowData)}/>
                &nbsp;   <Button icon="pi pi-trash" className="p-button-rounded p-button-warning"
                                 onClick={() => deleteGridData(rowData)}/>
            </>
        );
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearFilter1}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Keyword Search"/>
                </span>
                </div>
                <button type='button' onClick={() => setModal(!modal)} className='btn btn-primary'>Add Skill Matrix
                </button>
            </div>
        </div>
    );

    const footer =`In total there are ${state.skillMatrixs ? state.skillMatrixs.length : 0} Skill Matrix.`;

    const _isActiveColumn = (rowData) => {
        return <div>{rowData.active ? <>Active</> : <>Inactive</>}</div>
    }

    const Table = (
        <DataTable value={state.skillMatrixs}
                   showGridlines
                   dataKey="roleWiseMatrixID" filters={filters1} filterDisplay="menu"
                   globalFilterFields={['userRoleID', 'matrixTitle','weight','rca','active']}
                   header={header} footer={footer} paginator rows={7} first={start}
                   paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="roleWiseMatrixID" header="competencyTitleIndicatorID" hidden={true}/>            
            <Column field="userRoleID" header="Role" hidden={true}/> 
            <Column field="roleName" header="Role Name"/>                        
            <Column field='matrixTitle' header="Title"/>            
            <Column field='weight' header="Weight" />
            <Column field='rca' header="RCA" />
            <Column field='active' header="Active" body={_isActiveColumn}/>
            <Column body={actionBodyTemplate} header="Action" exportable={false} style={{minWidth: '4rem', textAlign:"center"}}/>
        </DataTable>
    )
	
    return (
        <Layout>
            <SkillMatrixForm
                isLoading={isLoading}                                
                setactiveUserRoleNames={activeUserRoleNames}
                roleWiseMatrixID={skillMatrixItem.roleWiseMatrixID}                 
                userRoleID={skillMatrixItem.userRoleID}                  
                matrixTitle={skillMatrixItem.matrixTitle}                
                weight={skillMatrixItem.weight}
                rca={skillMatrixItem.rca}
                active={skillMatrixItem.active}
                modal={modal}
                onSubmit={onSubmit}
                onHide={onHide}/>
            {Table}
        </Layout>
    )
}

export default SkillMatrix